import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { useViewer } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Button, Callout, GraphQLErrorMessage, Modal, Paragraph, Popover } from '@treams/treams-ui';

import { ConversationPartnerSelect } from '../create-conversation/ConversationPartnerSelect';

export default function ChangeConversationPartner(props: {
	id: string;
	employeeID: string;
	userID: string;
	enabled?: boolean;
	onCompleted?: () => void;
	onDismiss?: () => void;
}) {
	const { t } = useTranslation();
	const [userID, setUserID] = useState<string | undefined>(props.userID);
	const viewer = useViewer();
	const subjectType = viewer?.id === props.employeeID ? 'me' : 'partner';
	const [commit, { loading, error }] = graphql.useChangeConversationPartnerMutation({
		onCompleted: () => {
			setTimeout(() => {
				props.onCompleted?.();
				props.onDismiss?.();
			}, 1000);
		},
	});

	const save = async () => {
		if (!userID) {
			return;
		}

		await commit({
			variables: {
				input: {
					id: props.id,
					userID,
				},
			},
		});
	};

	return (
		<Popover visible center>
			<Modal width={400} height="auto">
				<Modal.Header
					title={t('evaluation.submission.changeConversationPartner.title')}
					onClose={() => props.onDismiss?.()}
				/>
				<Modal.Contents>
					{props.enabled ? (
						<>
							{error && <GraphQLErrorMessage error={error.graphQLErrors[0]} />}
							<Paragraph mb={3}>
								{t('evaluation.submission.changeConversationPartner.message')}
							</Paragraph>
							<Flex flexDirection="column">
								<Box mb={2}>
									<ConversationPartnerSelect
										value={{ subjectType, userID }}
										onChange={(value) => setUserID(value.userID)}
										hideSubjectSelect
									/>
								</Box>
								<Button
									small
									type="primary"
									title={t('evaluation.submission.changeConversationPartner.save')}
									onClick={save}
									loading={loading}
									disableSuccess={error !== undefined}
									disabled={userID === props.userID || userID === undefined}
								/>
							</Flex>
						</>
					) : (
						<Callout color="red">
							{t('evaluation.submission.changeConversationPartner.impossible')}
						</Callout>
					)}
				</Modal.Contents>
			</Modal>
		</Popover>
	);
}
